import { Typography } from '@mui/material';

type Props = {
    text: string;
};

const Subtitle = ({ text }: Props) => {
    return (
        <Typography variant={'subtitle1'} sx={{ margin: '10px 0' }}>
            {text}
        </Typography>
    );
};

export default Subtitle;
